module.exports = __webpack_public_path__ + "img/icon-phone.bfc0ec5d.svg";